import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useSEO } from '@/hooks/useSEO';

const produtos = [
  { icon: 'ri-armchair-line', title: 'Cadeiras Ergonômicas', desc: 'Frisokar e Plaxmetal com certificação NR-17. Entrega no Sertão de PE.', link: '/cadeiras' },
  { icon: 'ri-layout-grid-line', title: 'Mesas Corporativas', desc: 'Estações de trabalho e mesas de reunião Marzo Vitorino.', link: '/mesas' },
  { icon: 'ri-layout-masonry-line', title: 'Divisórias Modulares', desc: 'Vidro, painel e acústica. Instalação sem obra em Petrolina.', link: '/divisorias' },
  { icon: 'ri-volume-mute-line', title: 'Cabines Acústicas', desc: 'Isolamento de até 45dB para escritórios no Sertão.', link: '/cabines-acusticas' },
  { icon: 'ri-archive-line', title: 'Mobiliário de Aço', desc: 'Armários, estantes e lockers W3 Indústria.', link: '/aco' },
  { icon: 'ri-school-line', title: 'Mobiliário Escolar', desc: 'Conjuntos para escolas públicas e privadas do Sertão.', link: '/escolar' },
];

const diferenciais = [
  { icon: 'ri-truck-line', title: 'Entrega no Sertão', desc: 'Petrolina, Juazeiro, Lagoa Grande, Santa Maria da Boa Vista e toda a região do São Francisco.' },
  { icon: 'ri-tools-line', title: 'Montagem inclusa', desc: 'Nossa equipe instala tudo no seu escritório. Você não precisa se preocupar com nada.' },
  { icon: 'ri-time-line', title: 'Prazo para o Sertão', desc: 'Logística otimizada para Petrolina e região do São Francisco. Entrega rápida e segura.' },
  { icon: 'ri-shield-check-line', title: 'Garantia e suporte', desc: 'Assistência técnica no Sertão de Pernambuco. Garantia de até 5 anos nas cadeiras Frisokar.' },
];

const cidades = ['Petrolina', 'Juazeiro', 'Lagoa Grande', 'Santa Maria da Boa Vista', 'Orocó', 'Dormentes', 'Afrânio', 'Casa Nova', 'Remanso', 'Sento Sé', 'Pilão Arcado', 'Curacá'];

export default function MoveisCorporativosPetrolinaPage() {
  useSEO({
    title: 'Móveis Corporativos Petrolina PE | Cadeiras, Mesas e Divisórias — Home Office Premium',
    description: 'Móveis corporativos em Petrolina PE com entrega no Sertão e Vale do São Francisco. Cadeiras ergonômicas NR17, mesas corporativas, divisórias modulares e cabines acústicas. Atendemos Petrolina, Juazeiro e toda a região.',
    keywords: 'móveis corporativos Petrolina, cadeiras ergonômicas Petrolina, mesas corporativas Petrolina PE, divisórias modulares Petrolina, mobiliário escritório Petrolina, cadeiras escritório Petrolina, mesas escritório Petrolina, divisórias escritório Petrolina, mobiliário corporativo Sertão PE, cadeiras NR17 Petrolina, Frisokar Petrolina, Plaxmetal Petrolina, mobiliário escolar Petrolina, cabines acústicas Petrolina, armário aço Petrolina, móveis escritório Juazeiro, móveis escritório Lagoa Grande, mobiliário corporativo Vale São Francisco',
    path: '/moveis-corporativos-petrolina',
    ogTitle: 'Móveis Corporativos Petrolina PE | Home Office Premium',
    ogDescription: 'Móveis corporativos em Petrolina PE com entrega no Sertão e Vale do São Francisco. Cadeiras ergonômicas, mesas, divisórias e cabines acústicas.',
  });

  useEffect(() => {
    const schemaId = 'schema-petrolina';
    let script = document.getElementById(schemaId) as HTMLScriptElement | null;
    if (!script) { script = document.createElement('script'); script.id = schemaId; script.type = 'application/ld+json'; document.head.appendChild(script); }
    const siteUrl = import.meta.env.VITE_SITE_URL ?? '';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'Home Office Premium — Móveis Corporativos Petrolina',
      description: 'Móveis corporativos em Petrolina PE. Cadeiras ergonômicas, mesas corporativas, divisórias modulares e cabines acústicas com entrega no Sertão e Vale do São Francisco.',
      url: `${siteUrl}/moveis-corporativos-petrolina`,
      telephone: '+55-81-98203-0285',
      email: 'ednilsonleocadio@gmail.com',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Av. Agamenon Magalhães, 1519',
        addressLocality: 'Caruaru',
        addressRegion: 'PE',
        postalCode: '55014-000',
        addressCountry: 'BR',
      },
      geo: { '@type': 'GeoCoordinates', latitude: -9.3891, longitude: -40.5031 },
      areaServed: [
        { '@type': 'City', name: 'Petrolina' },
        { '@type': 'City', name: 'Juazeiro' },
        { '@type': 'City', name: 'Lagoa Grande' },
        { '@type': 'City', name: 'Santa Maria da Boa Vista' },
        { '@type': 'City', name: 'Orocó' },
        { '@type': 'City', name: 'Dormentes' },
        { '@type': 'City', name: 'Afrânio' },
        { '@type': 'City', name: 'Casa Nova' },
        { '@type': 'City', name: 'Remanso' },
        { '@type': 'City', name: 'Sento Sé' },
        { '@type': 'City', name: 'Pilão Arcado' },
        { '@type': 'City', name: 'Curacá' },
      ],
      serviceType: 'Venda e Instalação de Móveis Corporativos',
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Móveis Corporativos Petrolina',
        itemListElement: produtos.map((p, i) => ({
          '@type': 'Offer',
          position: i + 1,
          itemOffered: { '@type': 'Service', name: p.title, description: p.desc },
        })),
      },
    });

    const faqId = 'schema-petrolina-faq';
    let faqScript = document.getElementById(faqId) as HTMLScriptElement | null;
    if (!faqScript) { faqScript = document.createElement('script'); faqScript.id = faqId; faqScript.type = 'application/ld+json'; document.head.appendChild(faqScript); }
    faqScript.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'A Home Office Premium entrega móveis corporativos em Petrolina?',
          acceptedAnswer: { '@type': 'Answer', text: 'Sim. Entregamos e montamos móveis corporativos em Petrolina e toda a região do Vale do São Francisco, incluindo Juazeiro, Lagoa Grande, Santa Maria da Boa Vista, Orocó, Dormentes, Afrânio, Casa Nova, Remanso, Sento Sé, Pilão Arcado e Curacá.' },
        },
        {
          '@type': 'Question',
          name: 'Qual o prazo de entrega para Petrolina e região?',
          acceptedAnswer: { '@type': 'Answer', text: 'Para Petrolina e região do Vale do São Francisco, o prazo médio de entrega é de 10 a 20 dias úteis, dependendo do produto. Trabalhamos com transportadoras especializadas no Sertão.' },
        },
        {
          '@type': 'Question',
          name: 'Vocês fazem visita técnica em Petrolina?',
          acceptedAnswer: { '@type': 'Answer', text: 'Sim. Realizamos visita técnica em Petrolina e cidades próximas para medição, avaliação ergonômica e apresentação de projeto 3D. Agendamos com antecedência para otimizar a logística.' },
        },
        {
          '@type': 'Question',
          name: 'A montagem dos móveis está inclusa para Petrolina?',
          acceptedAnswer: { '@type': 'Answer', text: 'Sim. A montagem está inclusa para todos os pedidos em Petrolina e região. Nossa equipe própria ou parceiros credenciados fazem a instalação completa no seu escritório.' },
        },
        {
          '@type': 'Question',
          name: 'Vocês atendem empresas de agronegócio em Petrolina?',
          acceptedAnswer: { '@type': 'Answer', text: 'Sim. Atendemos empresas de agronegócio, cooperativas, escritórios de consultoria rural e indústrias do Vale do São Francisco com mobiliário robusto e durável.' },
        },
      ],
    });

    return () => { script?.remove(); faqScript?.remove(); };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="pt-20">
        {/* Hero */}
        <div className="relative bg-[#111111] overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="/media/ia/0389.webp"
              alt="Móveis corporativos em Petrolina PE"
              className="w-full h-full object-cover object-top opacity-30"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/85 to-black/40"></div>
          </div>
          <div className="relative z-10 max-w-7xl mx-auto px-6 py-24">
            <div className="max-w-2xl">
              <div className="inline-flex items-center gap-2 bg-[#E8610A]/20 border border-[#E8610A]/40 text-[#E8610A] text-xs font-semibold px-4 py-2 rounded-full mb-6 uppercase tracking-widest">
                <i className="ri-map-pin-line"></i>
                Petrolina e Vale do São Francisco
              </div>
              <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-5">
                Móveis Corporativos
                <span className="block text-[#E8610A]">em Petrolina</span>
              </h1>
              <p className="text-white/70 text-lg max-w-xl leading-relaxed mb-8">
                Cadeiras ergonômicas, mesas corporativas, divisórias modulares e cabines acústicas com entrega no Sertão de Pernambuco. Atendemos Petrolina, Juazeiro e toda a região do Vale do São Francisco.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href="https://wa.me/5581982030285?text=Oi%2C%20sou%20de%20Petrolina%20e%20quero%20um%20or%C3%A7amento%20de%20m%C3%B3veis%20corporativos"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 bg-[#E8610A] text-white font-semibold px-8 py-4 rounded-full hover:bg-[#C4500A] transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line"></i>
                  Solicitar Orçamento para Petrolina
                </a>
                <Link
                  to="/contato"
                  className="inline-flex items-center justify-center gap-2 bg-white/10 text-white font-semibold px-8 py-4 rounded-full border border-white/20 hover:bg-white/20 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-message-3-line"></i>
                  Falar com Especialista
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Produtos */}
        <div className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-14">
              <p className="text-[#E8610A] text-xs font-semibold uppercase tracking-widest mb-3">Catálogo</p>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Móveis Corporativos em Petrolina</h2>
              <p className="text-gray-500 mt-3 text-base max-w-lg mx-auto">Toda a linha de móveis corporativos com entrega no Sertão de Pernambuco.</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {produtos.map(p => (
                <Link
                  key={p.title}
                  to={p.link}
                  className="group bg-[#f8f8f6] rounded-2xl p-7 hover:bg-orange-50 transition-colors duration-300 cursor-pointer"
                >
                  <div className="w-12 h-12 flex items-center justify-center bg-white rounded-xl mb-5 group-hover:bg-[#E8610A] transition-colors duration-300">
                    <i className={`${p.icon} text-[#E8610A] text-xl group-hover:text-white transition-colors duration-300`}></i>
                  </div>
                  <h3 className="text-gray-900 font-bold text-base mb-2">{p.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{p.desc}</p>
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* Diferenciais */}
        <div className="py-20 bg-[#fafaf8]">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-14">
              <p className="text-[#E8610A] text-xs font-semibold uppercase tracking-widest mb-3">Por que escolher</p>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Vantagens para o Sertão</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {diferenciais.map(d => (
                <div key={d.title} className="bg-white rounded-2xl p-6 border border-gray-100">
                  <div className="w-11 h-11 flex items-center justify-center bg-[#E8610A]/10 rounded-xl mb-4">
                    <i className={`${d.icon} text-[#E8610A] text-xl`}></i>
                  </div>
                  <h3 className="text-gray-900 font-semibold text-base mb-2">{d.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{d.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Cidades */}
        <div className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-10">
              <p className="text-[#E8610A] text-xs font-semibold uppercase tracking-widest mb-3">Atendimento Regional</p>
              <h2 className="text-3xl font-bold text-gray-900">Cidades do Vale do São Francisco que Atendemos</h2>
              <p className="text-gray-500 mt-3 text-sm max-w-lg mx-auto">Entrega e montagem em toda a região do Sertão de Pernambuco e Bahia.</p>
            </div>
            <div className="flex flex-wrap gap-2 justify-center">
              {cidades.map(c => (
                <span key={c} className="bg-[#f8f8f6] text-gray-700 text-sm font-medium px-4 py-2 rounded-full border border-gray-100">
                  {c}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="py-16 bg-[#fafaf8]">
          <div className="max-w-7xl mx-auto px-6">
            <div className="bg-[#111111] rounded-3xl px-8 md:px-16 py-14 flex flex-col md:flex-row items-center justify-between gap-10 relative overflow-hidden">
              <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-[#E8610A] rounded-l-3xl"></div>
              <div>
                <p className="text-[#E8610A] text-xs font-semibold uppercase tracking-widest mb-3">Orçamento sem compromisso</p>
                <h2 className="text-3xl font-bold text-white mb-3">Móveis corporativos em Petrolina com entrega garantida</h2>
                <p className="text-white/60 text-base max-w-lg leading-relaxed">
                  Solicite um orçamento personalizado para seu escritório em Petrolina. Atendemos todo o Vale do São Francisco.
                </p>
              </div>
              <div className="flex flex-col gap-3 flex-shrink-0">
                <a
                  href="https://wa.me/5581982030285?text=Oi%2C%20sou%20de%20Petrolina%20e%20quero%20um%20or%C3%A7amento%20de%20m%C3%B3veis%20corporativos"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 bg-[#E8610A] text-white font-semibold px-8 py-4 rounded-full hover:bg-[#C4500A] transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line"></i>
                  WhatsApp Petrolina
                </a>
                <Link
                  to="/contato"
                  className="inline-flex items-center justify-center gap-2 bg-white/10 text-white font-semibold px-8 py-4 rounded-full border border-white/20 hover:bg-white/20 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-message-3-line"></i>
                  Formulário de Contato
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <a
        href="https://wa.me/5581982030285?text=Oi%2C%20sou%20de%20Petrolina%20e%20quero%20um%20or%C3%A7amento%20de%20m%C3%B3veis%20corporativos"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-[9999] w-14 h-14 flex items-center justify-center bg-[#25D366] rounded-full cursor-pointer hover:scale-110 transition-transform duration-200"
        aria-label="WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-2xl"></i>
      </a>
    </div>
  );
}